export default __webpack_public_path__ + "static/media/Tiger's Vest of the Painted Claw.22b5e9dc.jpg";